import React, { useCallback, useEffect } from 'react';
import { Accordion, Tab, Tabs, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CustomSeparator } from '../../Components';
import { alteraStatusdoXml } from '../../Funcoes/Validacao';
import { useValidadorXML } from '../../ValidadorContext';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';
import { ButtonCollapse } from './styles';
import { InputText } from '~/components/NovosInputs';
import { useForm } from 'react-hook-form';
import { formatBrPhone, formatCep, pontuaCpfCnpj } from '~/utils/functions';

const MySwal = withReactContent(Swal);

interface FunctionsProps {
  [index: string]: any;
}

export const CapaDivergencias: React.FC = () => {
  const {
    dadosDaCapa,
    dadosDoXML,
    dadosErpDoFornecedor,
    key,
    setKey,
    anchorPoint,
    setAnchorPoint,
    showContextMenu,
    setShowContextMenu,
    setCallableFunction,
    setDadosErpDoFornecedor,
    parametrosValidacao,
    itensDaTabela,
    callableFunction,
    showCapa,
    setShowCapa,
  } = useValidadorXML();

  const { register, control, setValue } = useForm();

  const onContextMenuClick = useCallback(
    (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
      e.preventDefault();
      const { id } = e.target as HTMLInputElement;
      setAnchorPoint({ x: e.pageX, y: e.pageY });
      setShowContextMenu(true);
      setCallableFunction(id);
    },
    [setAnchorPoint, setCallableFunction, setShowContextMenu],
  );

  function CreateTable(itens: any): void {
    const AlertTableHeader =
      '<tr><th style="text-align:left;padding-left: 10px;">CAMPOS</th><th>XML</th><th>ERP</th></tr>';

    const AlertTableBody = itens.map((item: any, index: number): string => {
      const [chave, valorErp, valorXml] = item;
      const spaco = '&nbsp;&nbsp;';
      const classe = index % 2 === 0 ? 'even' : 'odd';
      const campos: any = {
        num_cpf_cnpj: 'CNPJ',
        num_rg_ie: 'IE',
        des_fornecedor: 'Descrição',
        des_uf: 'UF',
        des_logradouro: 'Logradouro',
        num_endereco: 'Número',
        des_bairro: 'Bairro',
        num_cep: 'Cep',
        num_telefone: 'Telefone',
        des_cidade: 'Cidade',
      };

      const invalid = valorErp.invalid ? 'invalid-row' : '';

      return `<tr class='${classe} ${invalid}'>
                <td style='text-align: left; padding-left: 10px; font-weight: bold;border-right: 1px solid #f2f2f2; width: 30%;'>${campos[chave]}${spaco}</td>
                <td style='padding-right: 10px;'>${valorXml}${spaco}</td>
                <td>${valorErp.value}</td>
              </tr>`;
    });

    const AlertTable = `
      <style type="text/css">
        .invalid-row {
          background-color: #fdfdae !important;
        }
        .table-body tr:nth-child(even) {
          background-color: #f7f7f7;
        }
      </style>

      <div style='max-height: 300px; border: solid 1px #dcdcdc; overflow: auto'>
        <table style='width:100%;max-width: 1200px;table-layout: fixed;'>
          <thead>${AlertTableHeader}</thead>
          <tbody class="table-body">${AlertTableBody.join(' ')}</tbody>
        </table>
      </div>

      <p style='text-align: left; padding: 10px'></p>
    `;

    MySwal.fire({
      icon: 'info',
      width: 1200,
      title: 'XML X ERP',
      html: String(AlertTable),
    });
  }

  const listOfFunctions: FunctionsProps = {
    attDescricao: async () => {
      if (dadosDoXML?.fornecedor.xNome) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          des_fornecedor: {
            value: dadosDoXML.fornecedor.xNome,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attIeRg: async () => {
      if (dadosDoXML?.fornecedor.IE) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          num_rg_ie: {
            value: dadosDoXML.fornecedor.IE,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attCGC: async () => {
      if (dadosDoXML?.fornecedor.CNPJ) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          num_cpf_cnpj: {
            value: dadosDoXML.fornecedor.CNPJ,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attEndereco: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.xLgr) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          des_logradouro: {
            value: dadosDoXML.fornecedor.enderEmit.xLgr,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attNumEnd: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.nro) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          num_endereco: {
            value: dadosDoXML.fornecedor.enderEmit.nro,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attBairro: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.xBairro) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          des_bairro: {
            value: dadosDoXML.fornecedor.enderEmit.xBairro,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attCep: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.CEP) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          num_cep: {
            value: dadosDoXML.fornecedor.enderEmit.CEP,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attMunicipio: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.xMun) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          des_cidade: {
            value: dadosDoXML.fornecedor.enderEmit.xMun,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attUF: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.UF) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          des_uf: {
            value: dadosDoXML.fornecedor.enderEmit.UF,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attFone: async () => {
      if (dadosDoXML?.fornecedor.enderEmit.fone) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          num_telefone: {
            value: dadosDoXML.fornecedor.enderEmit.fone,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    attTodos: async () => {
      if (dadosDoXML?.fornecedor) {
        setDadosErpDoFornecedor({
          ...dadosErpDoFornecedor,
          num_cpf_cnpj: {
            value: dadosDoXML.fornecedor.CNPJ,
            invalid: false,
          },
          num_rg_ie: {
            value: dadosDoXML.fornecedor.IE,
            invalid: false,
          },
          des_fornecedor: {
            value: dadosDoXML.fornecedor.xNome,
            invalid: false,
          },
          apelido_fantasia: {
            value: dadosDoXML.fornecedor.xFant,
            invalid: false,
          },
          des_uf: {
            value: dadosDoXML.fornecedor.enderEmit.UF,
            invalid: false,
          },
          des_logradouro: {
            value: dadosDoXML.fornecedor.enderEmit.xLgr,
            invalid: false,
          },
          num_endereco: {
            value: dadosDoXML.fornecedor.enderEmit.nro,
            invalid: false,
          },
          des_bairro: {
            value: dadosDoXML.fornecedor.enderEmit.xBairro,
            invalid: false,
          },
          num_cep: {
            value: dadosDoXML.fornecedor.enderEmit.CEP,
            invalid: false,
          },
          num_telefone: {
            value: dadosDoXML.fornecedor.enderEmit.fone,
            invalid: false,
          },
          des_cidade: {
            value: dadosDoXML.fornecedor.enderEmit.xMun,
            invalid: false,
          },
          flg_produtor_rural: {
            value: false,
            invalid: false,
          },
        });
        await alteraStatusdoXml({
          codXml: Number(dadosDaCapa.cod_xml_cap),
          tipoIcmsSt: parametrosValidacao.icms_st,
          TipoIcmsOp: parametrosValidacao.icms_op,
          codPerfil: Number(parametrosValidacao.cod_perfil),
          dadosErpDoFornecedor,
          itensDaTabela,
        });
        return;
      }
      toast.error('Não foi possível atualizar os dados da capa.');
    },
    showDifferences: () => {
      const formatedComparison = Object.entries(dadosErpDoFornecedor).filter(
        (itens) =>
          [
            'des_fornecedor',
            'num_rg_ie',
            'num_cpf_cnpj',
            'des_logradouro',
            'num_endereco',
            'des_bairro',
            'num_cep',
            'des_cidade',
            'des_uf',
            'num_telefone',
          ].indexOf(itens[0]) >= 0,
      );
      for (let i = 0; i < formatedComparison.length; i++) {
        switch (formatedComparison[i][0]) {
          case 'des_fornecedor':
            formatedComparison[i].push(dadosDoXML?.fornecedor.xNome);
            break;
          case 'num_rg_ie':
            formatedComparison[i].push(dadosDoXML?.fornecedor.IE);
            break;
          case 'num_cpf_cnpj':
            formatedComparison[i].push(dadosDoXML?.fornecedor.CNPJ);
            break;
          case 'des_logradouro':
            formatedComparison[i].push(dadosDoXML?.fornecedor.enderEmit.xLgr);
            break;
          case 'num_endereco':
            formatedComparison[i].push(dadosDoXML?.fornecedor.enderEmit.nro);
            break;
          case 'des_bairro':
            formatedComparison[i].push(
              dadosDoXML?.fornecedor.enderEmit.xBairro,
            );
            break;
          case 'num_cep':
            formatedComparison[i].push(dadosDoXML?.fornecedor.enderEmit.CEP);
            break;
          case 'des_cidade':
            formatedComparison[i].push(dadosDoXML?.fornecedor.enderEmit.xMun);
            break;
          case 'des_uf':
            formatedComparison[i].push(dadosDoXML?.fornecedor.enderEmit.UF);
            break;
          case 'num_telefone':
            formatedComparison[i].push(dadosDoXML?.fornecedor.enderEmit.fone);
            break;

          default:
            break;
        }
        // formatedComparison[i].push();
      }

      CreateTable(formatedComparison);
    },
  };

  const handleClick = useCallback(
    () => (showContextMenu ? setShowContextMenu(false) : null),
    [setShowContextMenu, showContextMenu],
  );

  useEffect(() => {
    document.addEventListener('click', handleClick);
    // document.addEventListener('contextmenu', onContextMenuClick);
    return () => {
      document.removeEventListener('click', handleClick);
      // document.removeEventListener('contextmenu', onContextMenuClick);
    };
  }, [handleClick, showContextMenu]);

  const isStatusValid = useCallback((tipo_status: number): boolean => {
    return tipo_status >= 2;
  }, []);

  // Helper para normalizar valores
  const toStr = (x: unknown) =>
    x === undefined || x === null ? '' : String(x).trim();

  useEffect(() => {
    if (!dadosErpDoFornecedor) return;

    setValue(
      'des_fornecedor',
      toStr(dadosErpDoFornecedor.des_fornecedor?.value),
      { shouldDirty: false, shouldValidate: false },
    );
    setValue('num_rg_ie', toStr(dadosErpDoFornecedor.num_rg_ie?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('num_cpf_cnpj', toStr(dadosErpDoFornecedor.num_cpf_cnpj?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue(
      'des_logradouro',
      toStr(dadosErpDoFornecedor.des_logradouro?.value),
      { shouldDirty: false, shouldValidate: false },
    );
    setValue('num_endereco', toStr(dadosErpDoFornecedor.num_endereco?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('des_bairro', toStr(dadosErpDoFornecedor.des_bairro?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('num_cep', toStr(dadosErpDoFornecedor.num_cep?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('des_cidade', toStr(dadosErpDoFornecedor.des_cidade?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('des_uf', toStr(dadosErpDoFornecedor.des_uf?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('num_telefone', toStr(dadosErpDoFornecedor.num_telefone?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
  }, [dadosErpDoFornecedor, setValue]);

  // Preenche a aba XML (somente exibição)
  useEffect(() => {
    const f = dadosDoXML?.fornecedor;
    if (!f) return;

    setValue('xml_des_fornecedor', toStr(f.xNome), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_num_rg_ie', toStr(f.IE), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_num_cpf_cnpj', pontuaCpfCnpj(toStr(f.CNPJ)), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_des_logradouro', toStr(f.enderEmit?.xLgr), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_num_endereco', toStr(f.enderEmit?.nro), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_des_bairro', toStr(f.enderEmit?.xBairro), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_num_cep', formatCep(toStr(f.enderEmit?.CEP)), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_des_cidade', toStr(f.enderEmit?.xMun), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_des_uf', toStr(f.enderEmit?.UF), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('xml_num_telefone', formatBrPhone(toStr(f.enderEmit?.fone)), {
      shouldDirty: false,
      shouldValidate: false,
    });
  }, [dadosDoXML, setValue]);

  // Preenche a aba ERP (somente exibição)
  useEffect(() => {
    if (!dadosErpDoFornecedor) return;

    setValue(
      'erp_des_fornecedor',
      toStr(dadosErpDoFornecedor.des_fornecedor?.value),
      { shouldDirty: false, shouldValidate: false },
    );
    setValue('erp_num_rg_ie', toStr(dadosErpDoFornecedor.num_rg_ie?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue(
      'erp_num_cpf_cnpj',
      pontuaCpfCnpj(toStr(dadosErpDoFornecedor.num_cpf_cnpj?.value)),
      { shouldDirty: false, shouldValidate: false },
    );
    setValue(
      'erp_des_logradouro',
      toStr(dadosErpDoFornecedor.des_logradouro?.value),
      { shouldDirty: false, shouldValidate: false },
    );
    setValue(
      'erp_num_endereco',
      toStr(dadosErpDoFornecedor.num_endereco?.value),
      { shouldDirty: false, shouldValidate: false },
    );
    setValue('erp_des_bairro', toStr(dadosErpDoFornecedor.des_bairro?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue(
      'erp_num_cep',
      formatCep(toStr(dadosErpDoFornecedor.num_cep?.value)),
      {
        shouldDirty: false,
        shouldValidate: false,
      },
    );
    setValue('erp_des_cidade', toStr(dadosErpDoFornecedor.des_cidade?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue('erp_des_uf', toStr(dadosErpDoFornecedor.des_uf?.value), {
      shouldDirty: false,
      shouldValidate: false,
    });
    setValue(
      'erp_num_telefone',
      formatBrPhone(toStr(dadosErpDoFornecedor.num_telefone?.value)),
      { shouldDirty: false, shouldValidate: false },
    );
  }, [dadosErpDoFornecedor, setValue]);

  return (
    <>
      {showContextMenu && (
        <ul
          className="menu"
          style={{
            top: anchorPoint.y,
            left: anchorPoint.x,
          }}
        >
          <li>
            <button
              type="button"
              onClick={() => {
                listOfFunctions[callableFunction]();
              }}
            >
              Atualizar este campo
            </button>
          </li>
          <li>
            <button type="button" onClick={() => listOfFunctions.attTodos()}>
              Atualizar todos os campos
            </button>
          </li>
          <hr className="divider" />
          <li>
            <button
              type="button"
              onClick={() => listOfFunctions.showDifferences()}
            >
              Ver diferenças
            </button>
          </li>
        </ul>
      )}
      <Accordion defaultActiveKey="0">
        <div className="row capa-tabs">
          <div className="col-12" style={{ paddingRight: '0px' }}>
            <CustomSeparator label="Capa" eventKey="1" onChange={() => null}>
              {showCapa === '0' && (
                <>
                  <button
                    type="button"
                    onClick={() => setKey('divergencias')}
                    className={key === 'divergencias' ? 'active' : ''}
                  >
                    Divergências
                  </button>
                  <button
                    type="button"
                    onClick={() => setKey('xml')}
                    className={key === 'xml' ? 'active' : ''}
                  >
                    XML
                  </button>
                  <button
                    type="button"
                    onClick={() => setKey('erp')}
                    className={key === 'erp' ? 'active' : ''}
                  >
                    ERP
                  </button>
                </>
              )}

              <ButtonCollapse
                type="button"
                isOppened={showCapa}
                onClick={() => {
                  setShowCapa((prev) => (prev === '0' ? '1' : '0'));
                }}
                className="active"
              >
                {showCapa === '1' && (
                  <BiChevronDown
                    color="#fff"
                    size={20}
                    style={{ marginTop: '-2px' }}
                  />
                )}
                {showCapa === '0' && (
                  <BiChevronUp
                    color="#fff"
                    size={20}
                    style={{ marginTop: '-2px' }}
                  />
                )}
              </ButtonCollapse>
            </CustomSeparator>
          </div>
        </div>
        <div id="accordionParams" className="accordion">
          <Accordion.Collapse
            as={Button}
            eventKey={showCapa}
            className="row params-data"
          >
            <div className="row data-comparison">
              <Tabs
                id="controlled-tab-cliente"
                activeKey={key}
                onSelect={(k) => setKey(`${k}`)}
              >
                {/* DIVERGÊNCIAS */}
                <Tab eventKey="divergencias" title="">
                  <section>
                    <div className="row">
                      <div className="col-sm-12 col-md-8">
                        <InputText
                          id="attDescricao"
                          label="Descrição"
                          name="des_fornecedor"
                          placeholder="Descrição"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          style={{
                            backgroundColor: dadosErpDoFornecedor.des_fornecedor
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          id="attIeRg"
                          label="RG/IE"
                          name="num_rg_ie"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Insc. Estadual"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.num_rg_ie
                              ?.invalid
                              ? '#ef5350'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          id="attCGC"
                          label="CNPJ/CPF"
                          name="num_cpf_cnpj"
                          placeholder="CNPJ/CPF"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          style={{
                            backgroundColor: dadosErpDoFornecedor.num_cpf_cnpj
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-9">
                        <InputText
                          id="attEndereco"
                          label="Endereço"
                          name="des_logradouro"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Endereço"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.des_logradouro
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-1">
                        <InputText
                          id="attNumEnd"
                          label="Número"
                          name="num_endereco"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Número"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.num_endereco
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          id="attBairro"
                          label="Bairro"
                          name="des_bairro"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Bairro"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.des_bairro
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          id="attCep"
                          label="CEP"
                          name="num_cep"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="CEP"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.num_cep
                              ?.invalid
                              ? '#ef5350'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <InputText
                          id="attMunicipio"
                          label="Município"
                          name="des_cidade"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Município"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.des_cidade
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-1">
                        <InputText
                          id="attUF"
                          label="UF"
                          name="des_uf"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="UF"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.des_uf
                              ?.invalid
                              ? '#ef5350'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          id="attFone"
                          label="Fone"
                          name="num_telefone"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Telefone"
                          style={{
                            backgroundColor: dadosErpDoFornecedor.num_telefone
                              ?.invalid
                              ? '#ffff81'
                              : 'inherit',
                          }}
                          onChange={() => null}
                          isDisabled={dadosDaCapa.tipo_status >= 2}
                          onContextMenu={(e) => {
                            if (!isStatusValid(dadosDaCapa.tipo_status)) {
                              onContextMenuClick(e);
                            }
                          }}
                          title="Botão direito do mouse para + opções"
                        />
                      </div>
                    </div>
                  </section>
                </Tab>

                {/* XML */}
                <Tab eventKey="xml" title="">
                  <section>
                    <div className="row">
                      <div className="col-sm-12 col-md-8">
                        <InputText
                          label="Descrição"
                          name="xml_des_fornecedor"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Descrição"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="Insc. Estadual"
                          name="xml_num_rg_ie"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Insc. Estadual"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="CNPJ/CPF"
                          name="xml_num_cpf_cnpj"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="CNPJ/CPF"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-9">
                        <InputText
                          label="Endereço"
                          name="xml_des_logradouro"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Endereço"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-1">
                        <InputText
                          label="Número"
                          name="xml_num_endereco"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Número"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="Bairro"
                          name="xml_des_bairro"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Loja"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="CEP"
                          name="xml_num_cep"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="CEP"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <InputText
                          label="Município"
                          name="xml_des_cidade"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Município"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-1">
                        <InputText
                          label="UF"
                          name="xml_des_uf"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="UF"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="Fone"
                          name="xml_num_telefone"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Fone"
                          onChange={() => null}
                        />
                      </div>
                    </div>
                  </section>
                </Tab>

                {/* ERP */}
                <Tab eventKey="erp" title="">
                  <section>
                    <div className="row">
                      <div className="col-sm-12 col-md-8">
                        <InputText
                          label="Descrição"
                          name="erp_des_fornecedor"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Descrição"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="Insc. Estadual"
                          name="erp_num_rg_ie"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Insc. Estadual"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="CNPJ/CPF"
                          name="erp_num_cpf_cnpj"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="CNPJ/CPF"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-9">
                        <InputText
                          label="Endereço"
                          name="erp_des_logradouro"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Endereço"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-1">
                        <InputText
                          label="Número"
                          name="erp_num_endereco"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Número"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="Bairro"
                          name="erp_des_bairro"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Bairro"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="CEP"
                          name="erp_num_cep"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="CEP"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-4">
                        <InputText
                          label="Município"
                          name="erp_des_cidade"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Município"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-1">
                        <InputText
                          label="UF"
                          name="erp_des_uf"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="UF"
                          onChange={() => null}
                        />
                      </div>
                      <div className="col-sm-12 col-md-2">
                        <InputText
                          label="Fone"
                          name="erp_num_telefone"
                          control={control}
                          register={register}
                          maxLength={50}
                          isError={false}
                          placeholder="Telefone"
                          onChange={() => null}
                        />
                      </div>
                    </div>
                  </section>
                </Tab>
              </Tabs>
            </div>
          </Accordion.Collapse>
        </div>
      </Accordion>
    </>
  );
};
